import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { LocationProvider } from "./context/LocationContext";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <LocationProvider>
      <App />
    </LocationProvider>
  </React.StrictMode>
);

/* ===============================
   🔥 OFFLINE + UPDATE SERVICE WORKER
   =============================== */

if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      // 🔄 Update old service workers
      const registrations = await navigator.serviceWorker.getRegistrations();
      registrations.forEach((reg) => reg.update());

      // 🔥 Register offline service worker
      const registration = await navigator.serviceWorker.register(
        "/service-worker.js"
      );

      console.log("✅ Service Worker registered:", registration.scope);

      // 🚀 Detect new update (IMPORTANT)
      registration.onupdatefound = () => {
        const newWorker = registration.installing;

        newWorker.onstatechange = () => {
          if (newWorker.state === "installed") {
            if (navigator.serviceWorker.controller) {
              console.log("🚀 New version available");

              // 👇 tumhara existing system trigger hoga
              window.dispatchEvent(new Event("appUpdate"));
            }
          }
        };
      };

    } catch (error) {
      console.error("❌ Service Worker error:", error);
    }
  });
}